import React from "react";
import {useNavigate} from "react-router";
import Button from "@mui/material/Button";

export default function NextButton({ disabled, step }) {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate(`/shopping/cart/${step}`);
  };

  return (
    <Button
      disabled={disabled}
      size="large"
      color="primary"
      variant="contained"
      onClick={handleNext}
    >
      Next
    </Button>
  );
}
